'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTransformRequest;

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _getCookie = require('./getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// 设置POST等请求 body 序列化
function createTransformRequest(_ref) {
  var AuthorizationKey = _ref.AuthorizationKey,
      tokenKey = _ref.tokenKey,
      transformRequest = _ref.transformRequest,
      setBodyAuth = _ref.setBodyAuth;

  if (!Array.isArray(transformRequest)) {
    transformRequest = [transformRequest];
  }

  transformRequest = transformRequest.filter(function (_) {
    return typeof _ === 'function';
  });

  return [
  // 前置处理
  function (body) {
    return body || {};
  }].concat(_toConsumableArray(transformRequest), [
  // 后置处理
  function (body, headers) {
    var data = body || {};

    if (setBodyAuth) {
      !data[AuthorizationKey] && (data[AuthorizationKey] = headers[AuthorizationKey] || (0, _getCookie2.default)(tokenKey));
    }

    return data;
  }, function (body, headers) {
    (0, _util.normalizeHeaderName)(headers, 'Content-Type');

    var contentType = headers['Content-Type'] || headers.common['Content-Type'] || '';

    if (contentType.indexOf('application/json') > -1 && (0, _util.isPlainObject)(body)) {
      return JSON.stringify(body);
    }

    if ((0, _util.isURLSearchParams)(body)) {
      return body.toString();
    }

    if ((0, _util.isPlainObject)(body)) {
      return _querystring2.default.stringify(body);
    }

    return body;
  }]);
}